module.exports = __webpack_public_path__ + "static/img/liber.5692d900.png";